export default __webpack_public_path__ + "static/PeopleAnalytics-bg-2bf165a96ff7214ef8354f6f257b8685.png";